import React from "react";
//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
//#region types
import { SupportIssueMoreActionProps } from "models/propTypes/supportIssuePropTypes";
import { MoreActionMenuItemType } from "models/propTypes/menuPropTypes";
import { AuthEnums } from "models/enums";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
//#region components
import { MoreActions, useCheckRelations } from "components/common";
import useMessageForwardAction from "./actions/useMessageForwardAction";
import useMessageSnoozeAction from "./actions/useMessageSnoozeAction";
//#endregion
import { CompanyService } from "services";

const SupportIssueMoreActions: React.FC<SupportIssueMoreActionProps> = (props) => {
  const { reloadHandler, supportIssue, disableSuccessMessages } = props;
  const loggedInUser = useSelector((state: AppState) => state.auth.loggedInUser);

  const forwardAction = useMessageForwardAction(
    supportIssue.id,
    reloadHandler,
    supportIssue.isConfidential,
    supportIssue.isAgencyCase
  );
  const snoozeAction = useMessageSnoozeAction(supportIssue.id, reloadHandler);

  const { getIsAdmin } = useCheckRelations();
  const isAdmin = getIsAdmin();

  const getMenuItems = (): MoreActionMenuItemType[] => {
    const actions: MoreActionMenuItemType[] = [];
    if (supportIssue.state === WintSuperkollAPIModel.SupportIssueState.Closed) return actions;

    const isAuditor = CompanyService.hasRelation(AuthEnums.PersonCompanyRelationType.Auditor);
    if (!isAuditor) {
      // On a stamped case the server's own canForward already encodes every condition
      // AgencyForwardAsync enforces (owned by the byrå, not locked, viewer is an agency member) —
      // including hiding the action entirely from a customer person, who is never an agency member.
      // The admin/owner check below is the pre-byrasupport rule and stays exactly as it was for an
      // ordinary ticket, which knows nothing about agency membership.
      const canForward = supportIssue.isAgencyCase
        ? supportIssue.canForward
        : isAdmin || loggedInUser.personId === props.supportIssue.user?.id;
      canForward && actions.push(forwardAction);
      if (supportIssue.state === WintSuperkollAPIModel.SupportIssueState.AtCustomer) {
        actions.push(snoozeAction);
      }
    }

    return actions;
  };

  return <MoreActions menuItems={getMenuItems()} disableSuccessMessages={disableSuccessMessages} />;
};

export default SupportIssueMoreActions;
